
// Import icons of person and menu
import { FaUserAlt } from "react-icons/fa";
import { IoBusiness } from "react-icons/io5";
import React from 'react';

// Make a function that capitalizes the first letter of each word in a string

function capitalizeFirstLetter(string) {


    // If empty string, return empty string
    if (string === ''){
        console.log("Empty string")
        return ''
    }

    // Convert all string to lowercase
    string = string.toLowerCase();

    let words = string.split(" ");

    // Remove empty strings
    words = words.filter(function (el) {
        return el != "";
    });

    // console.log("Words: ")
    // console.log(words)


    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    
    return words.join(" ");
}

function ShowUserInfo({persona_beneficiada}){

    // Important: function must start in mayus, variable name with lowercase


    // console.log("Show user info")

    // console.log("persona_beneficiada: ")
    // console.log(persona_beneficiada)

    // If length of persona_beneficiada array is zero, then return empty div
    if (persona_beneficiada.length === 0){
        return (
            // <div></div>
            null
        )
    }


    
    

    // if (persona_beneficiada === ''){
    //     return (
    //         // <div></div>
    //         null
    //     )
    // }

    else{
        // Each name has the name and the id number, separated by a _, so split each name in the array by the _
        let names = persona_beneficiada.map(name => name.split("_")[0]);

        // Create a string with all the names
        names = names.join(", ");
        
        return (
            <span className="flex items-center text-gray-500">
                <FaUserAlt className="h-5 w-5 mr-2" />
                {/* {capitalizeFirstLetter(persona_beneficiada)} */}
                {names}
            </span>
        )
    }
}


// export default function ResultBox({query}){
function ResultBox({query}){


    // const results = props;
    console.log("From ResultBox.jsx")

    // Print length of query and filteredResults
    console.log("Length of query: ")
    console.log(query.found)

    console.log("Query: ")
    console.log(query);

    // If query is empty or undefined, then return an empty div
    if (query === '' || query === undefined){
        return (
            <div></div>
        )
    }

    const hits = query.hits;
    console.log(hits);

    // From each hit, extract the document
    let documents = hits.map(hit => hit.document);


    // If fecha is empty, then replace it with 'No date'
    documents.forEach(function (document) {

        if (document.fecha_de_firma === 0) {
            document.fecha_de_firma = "Sin fecha";
        }
        else{
            // console.log(document.fecha_adjudicacion)
            document.fecha_de_firma = new Date(document.fecha_de_firma * 1000).toLocaleDateString("es-CO");
        }

        if (document.fecha_de_inicio_del_contrato === 0) {
            document.fecha_de_inicio_del_contrato = "Sin fecha";
        }

        else{
            // console.log("fecha_de_publicacion_fase_seleccion")
            // console.log(document.fecha_de_publicacion_fase_seleccion)
            document.fecha_de_inicio_del_contrato = new Date(document.fecha_de_inicio_del_contrato * 1000).toLocaleDateString("es-CO");
        }

        // Add new variable date to document, if fecha_de_firma is empty, then use fecha_de_publicacion_fase_seleccion, else use fecha_de_firma
        if (document.fecha_de_firma === "Sin fecha"){
            document.date = document.fecha_de_publicacion_fase_seleccion;
        }
        else{
            document.date = document.fecha_de_firma;
        }

        // If ciudad is empty, then replace it with departamento value
        if (document.ciudad === 'No Definido') {
            document.ciudad = document.departamento;
        } 



    });


    const myElementStyle = {
        // fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
        // fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
        fontSize: "15px",
      };

    //   Make item.entidad a link

    return (
        <section className="pt-8 max-w-screen-lg mx-auto px-4 md:px-8">
            {/* <div>
                <h1 className="text-gray-800 text-3xl font-semibold">
                    Explore The Jobs
                </h1>
            </div> */}

            {/* Ul and section had mt-12 */}
            <ul className="space-y-6"> 
                {
                    documents.map((item, idx) => (
                        <li key={idx} className="p-8 px-8 bg-white rounded-md shadow-sm">
                            <a href={item.urlproceso} target="_blank">
                                <div>
                                    <div className="justify-between sm:flex">
                                        <div className="flex-1">
                                            <h3 className="text-xl font-medium text-blue-700 ">
                                                {capitalizeFirstLetter(item.nombre_entidad)}
                                            </h3>
                                            <p className="text-gray-500 mt-2 pr-6" style={myElementStyle}>
                                                {item.descripcion_del_proceso}
                                            </p>
                                        </div>
                                
                                        <div className="pt-1.5 mt-5 space-y-4 text-sm sm:mt-0 sm:space-y-2">
                                            <span className="flex items-center text-gray-500">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                                                </svg>
                                                {item.date}
                                            </span>

                                            <span className="flex items-center text-gray-500">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                                </svg>
                                                {item.ciudad}
                                            </span>
                                            <span className="flex items-center text-gray-500">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                                    <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
                                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd" />
                                                </svg>
                                                {"$"+ item.valor_del_contrato + " M"}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="mt-4 items-center space-y-4 text-sm sm:flex sm:space-x-4 sm:space-y-0">
                                        <span className="flex items-center text-gray-500">
                                            <IoBusiness className="h-5 w-5 mr-2 " />
                                            {capitalizeFirstLetter(item.proveedor_adjudicado)}
                                        </span>
                                        <span className="flex items-center text-gray-500">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z" clipRule="evenodd" />
                                                <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" />
                                            </svg>
                                            {item.modalidad_de_contratacion}
                                        </span>
                                        {/* <span className="flex items-center text-gray-500">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                            </svg>
                                            {item.ciudad_entidad}
                                        </span> */}

                                    </div>

                                    <div className="mt-4 items-center space-y-4 text-sm sm:flex sm:space-x-4 sm:space-y-0">
                                        <ShowUserInfo persona_beneficiada={item.miembros} />
                                    </div>
                                </div>
                            </a>
                        </li>
                    ))
                }
            </ul>
        </section>
    )
}

export default React.memo(ResultBox);